export const trackEvent = (eventName, params = {}) => {

  // ---------- Google Analytics ----------
  if (window.gtag) {
    window.gtag("event", eventName, params);
  }

  // ---------- Microsoft Clarity ----------
  if (window.clarity) {

    let clarityEventName = eventName;

    // Convert params object to string like: key1:value1|key2:value2
    if (params && Object.keys(params).length > 0) {
      const paramString = Object.entries(params)
        .map(([key, value]) => `${key}:${value}`)
        .join("|");

      clarityEventName = `${eventName}|${paramString}`;
    }

    window.clarity("event", clarityEventName);
  }
};

export const trackPageView = (path, extra = {}) => {
  trackEvent("page_view", {
    path,
    ...extra
  });
};
